// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__pBQrx","actions":"GroupTable_actions__1gm8c","deleteModalFooter":"GroupTable_deleteModalFooter__3zbVe"};